import { Component, computed, effect, OnInit, signal, WritableSignal } from '@angular/core';
import { AvailableColumn, ValidationListColumn } from '@app/common/models';
import { Store, select } from '@ngrx/store';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ColumnTypes, NumberRangeValue, NumberValue, TextValue, DateRangeValue, BoolValue, ListValue, DateValue, DynListValue as DynamicListValue, DynListOption, ItemValueModel, ItemValueListTypeTable, EANValue } from '@app/common/models/columnBase.model';
import { filter, Observable, of, take } from 'rxjs';
import { ISetting, ISettingChildrenValue, ISettingValue, SettingValueEnum, SettingValueTypeEnum } from '@app/common/models/setting.models';


import { CommonCheckService, CommonDataService, GetSettingsChildrenAction, GetSettingsStateAction, NovitaetenLookupService } from 'FoxxyLib';

import { GetAllAvailableColumnsAction, GetStaticListValuesAction, selectAllAvailableColumns, selectStaticUsedlistValues, selectValidationColumnsForList, selectValidationselectedColumnsForList, UpdateStaticListValuesAction } from '../store';
import { SelectChangeEvent } from 'primeng/select';

@Component({
    selector: 'app-editvalidationcolumn-view',
    templateUrl: 'editValidationColumn.dialog.component.html',
    styleUrls: ['./dialogs.component.scss'],
    standalone: false,
    providers: [CommonDataService]
})

export class EditValidationColumnDialogComponent implements OnInit {

  validationColumnToView: ValidationListColumn;
  numberRangeValue: NumberRangeValue = { numberrangestart: 0, numberrangeend: 0 };
  dateRangeValue: DateRangeValue = { daterangestart: new Date, daterangeend: new Date };
  numberValue: NumberValue = {  maxdecimals: 0, maxdigits: 0, isnumberonly: false, requiredcolumnvalue: null, minNumber: 0, maxNumber: 0, notcolumnvalue: null };
  textValue: TextValue = { maxlength: 120, validregex: null, minlength: 0, requiredcolumnvalue: null, notcolumnvalue: null };
  eanValue: EANValue = { value: undefined };
  listValue: ListValue = { valuelist: [] };
  checkBoxValue: BoolValue = { value: null, requiredcolumnvalue: null ,  notcolumnvalue: null};
  dateValue: DateValue = { value: null };
  dynListOptions: DynamicListValue[] = [];
  dynmlistValue: DynamicListValue = null
  moebeldynmlistValue: DynamicListValue = null;


  colTypeOptions: { label: string, value: number }[] = [];
  colEnum: any;
  datePickerOpen = false;

  settingList: WritableSignal<ISetting[]> = signal([]);
  settingValueList: WritableSignal<ISettingValue[]> = signal([]);
  selecteddbMapping: WritableSignal<ISettingValue> = signal(null);
  selectedChildren: WritableSignal<{ [key: string]: ISettingChildrenValue[] }> = signal({});
  hint: WritableSignal<string> = signal(null);

  selectStaticUsedlistValues$: Observable<{ [key: number]: ItemValueModel[] }> = of({});
  selectAllAvailableColumns$: Observable<AvailableColumn[]>;
  fndAvailablecol: AvailableColumn;
  validationListColumns$: Observable<ValidationListColumn[]>;

  referenceColumnValuesDynListOptions: WritableSignal<ItemValueModel[]> = signal([]);
  referenceColumnValueDynList: string;
  referenceNOTColumnValueDynList: string[];

  referenceColumnValueNumberListOptions: WritableSignal<ItemValueModel[]> = signal([]);
  allColumns: ValidationListColumn[];



  constructor(
    private store: Store<any>,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private validater: CommonCheckService,
    private commondataservice : CommonDataService
  ) {

    this.selectStaticUsedlistValues$ = this.store.pipe(select(selectStaticUsedlistValues));

    this.selectAllAvailableColumns$ = this.store.pipe(select(selectAllAvailableColumns))

    this.validationListColumns$ = this.store.pipe(select(selectValidationselectedColumnsForList));

    effect(() => {
      const mapp = this.selecteddbMapping();
      if ( mapp && mapp.isActive == 0)
      {
        this.hint.set('Das Db-Mapping wurde nicht gefunden. ');
      }
    } );

  }


  referenceNOTColumnValueNumberListOptions = computed(()=>
  {
      const gesetzt = this.referenceColumnValueDynList ?? this.numberValue?.requiredcolumnvalue
      ?? this.checkBoxValue?.requiredcolumnvalue ?? this.textValue?.requiredcolumnvalue;
      return this.referenceColumnValueNumberListOptions().filter(f=> gesetzt == undefined || f.value != gesetzt  );
  })

  ngOnInit() {

    const keys1 = Object.keys(DynListOption).filter(key => !isNaN(DynListOption[key]));
    keys1.forEach(x => this.dynListOptions.push({ label: x, value: DynListOption[x] }));
    this.dynmlistValue = this.dynListOptions.find(f => f.value == this.config.data.validationColumnToView.listOptions);

    //nur Möbel Options zur Zeit, keine Auswahl
    this.moebeldynmlistValue = this.dynListOptions.find(f => f.value == DynListOption.MöbeldesSortimentsundModul);

    this.validationColumnToView = this.config.data.validationColumnToView;

    this.allColumns = this.config.data.allColumns;
    this.referenceColumnValueNumberListOptions.set(this.allColumns.filter(f=> f.colName != this.validationColumnToView.colName
      && f.dbMapping
      && (f.colType == ColumnTypes.Number
        || f.colType == ColumnTypes.CheckBox
        || f.colType == ColumnTypes.Text
        || f.colType == ColumnTypes.DynamicList )
     ).map(x => <ItemValueModel>{ label: x.colName, value: x.dbMapping }));

     this.referenceColumnValuesDynListOptions.set(this.allColumns.filter(f=> f.colName != this.validationColumnToView.colName
      && f.dbMapping
      && (f.colType == ColumnTypes.Number
        || f.colType == ColumnTypes.CheckBox
        || f.colType == ColumnTypes.Text
        || f.colType == ColumnTypes.DynamicList )
     ).map(x => <ItemValueModel>{ label: x.colName, value: x.dbMapping }));

    if (this.validationColumnToView.colType == ColumnTypes.List) {

      this.store.dispatch(new GetStaticListValuesAction({ columnlistid: this.validationColumnToView.id, listtabletype: ItemValueListTypeTable.LISTCOLUMNS }));

    }



      switch (this.validationColumnToView.colType) {

        case ColumnTypes.EAN:


          break;
        case (ColumnTypes.Text):

          this.textValue.maxlength = this.validationColumnToView.maxLength && this.validationColumnToView.maxLength > 0 ? this.validationColumnToView.maxLength : 120;
          this.textValue.minlength = this.validationColumnToView.minLength ? this.validationColumnToView.minLength :  0;
          this.textValue.validregex = this.validationColumnToView.validRegEx;
          this.textValue.requiredcolumnvalue = this.validationColumnToView?.requiredColumnValue;
          this.textValue.notcolumnvalue = this.validationColumnToView?.notColumnValue?.split(";");

          break;
        case (ColumnTypes.DateRange):
          //not used


          break;
        case (ColumnTypes.NumberRange):
          //not used

          break;
        case (ColumnTypes.List):

          this.selectStaticUsedlistValues$.subscribe(data => {
            if (data && this.validationColumnToView.id > 0 && data[this.validationColumnToView.id]) {
              this.listValue.valuelist = data[this.validationColumnToView.id].map(x => <any>{ item: x.value });;
            }
          })

          break;
        case (ColumnTypes.Number):

          this.numberValue.isnumberonly = this.validationColumnToView.isNumberOnly == 1;
          this.numberValue.maxdigits = this.validationColumnToView.maxDigits;
          this.numberValue.maxdecimals = this.validationColumnToView.maxDecimals;
          this.numberValue.requiredcolumnvalue = this.validationColumnToView.requiredColumnValue;
          this.numberValue.notcolumnvalue = this.validationColumnToView?.notColumnValue?.split(";");

          this.numberValue.minNumber = this.validationColumnToView.minNumber;
          this.numberValue.maxNumber = this.validationColumnToView.maxNumber;
          break;
        case (ColumnTypes.CheckBox):

          this.checkBoxValue.requiredcolumnvalue = this.validationColumnToView.requiredColumnValue;
          this.checkBoxValue.notcolumnvalue = this.validationColumnToView?.notColumnValue?.split(";");

          break;
        case (ColumnTypes.Date):

          break;
        case (ColumnTypes.DynamicList):
          this.dynmlistValue = { ...this.dynListOptions.find(f => f.value == this.validationColumnToView.listOptions) };
          this.referenceColumnValueDynList = this.validationColumnToView.requiredColumnValue;
          this.referenceNOTColumnValueDynList = this.validationColumnToView.notColumnValue?.split(";");
          break;

    }


    const keys = Object.keys(ColumnTypes).filter(key => !isNaN(ColumnTypes[key]));
    keys.forEach(x => this.colTypeOptions.push({ label: x, value: ColumnTypes[x] }));

    this.colEnum = ColumnTypes;



    this.store.dispatch(new GetSettingsStateAction({ settingid: SettingValueEnum.DBMapping, onlyActive: true }));

    this.commondataservice.selectSettingValues.pipe(filter(f => f && f.length > 0), take(1)).subscribe(d => {
      if (this.validationColumnToView.dbMapping && !d.find(f => f.settingValue == this.validationColumnToView.dbMapping)) {
        d = this.validater.getClone(d);
        const current = <ISettingValue>{ id: 0, setting_Id: SettingValueEnum.DBMapping, settingValue: this.validationColumnToView.dbMapping, isActive: 0 };
        d.unshift(current);
      }

      this.settingValueList.set(d);
      this.selecteddbMapping.set(d.find(f => f.settingValue == this.validationColumnToView.dbMapping));
      if (this.selecteddbMapping()) {
        this.changeDbMapping({ value: this.selecteddbMapping(), originalEvent: null }, true);
      }

    }
    )

  }


  changeListenTyp(e)
  {
    if ( e.value == ColumnTypes.DynamicList) {
      this.dynmlistValue = this.moebeldynmlistValue;
    } else
    {
      this.dynmlistValue = null;
    }
  }

  changeDynList(e) {
    this.dynmlistValue = e.value;
  }

  clearDbMapping() {
    this.validationColumnToView = this.validater.getClone(this.validationColumnToView);
    this.validationColumnToView.colType = ColumnTypes.Text;
    this.validationColumnToView.dbMapping = null;
    this.validationColumnToView.bubMapping = null;
  }

  changeDbMapping(e: SelectChangeEvent, init: boolean = false) {


    this.validationColumnToView = this.validater.getClone(this.validationColumnToView);

    if (!init) {
      this.hint.set(null);
      this.validationColumnToView.dbMapping = e.value.settingValue;
      this.validationColumnToView.bubMapping = null;
    }
    if (this.selectedChildren()[e.value.id] == undefined || this.selectedChildren()[e.value.id].length == 0) {
      this.store.dispatch(new GetSettingsChildrenAction({ settingvalueId: e.value.id }));
    }
    this.commondataservice.selectSettingChildrenValues.subscribe(data => {
      const elements = data[e.value.id];
      if (elements instanceof Array) {

        this.validationColumnToView = this.validater.getClone(this.validationColumnToView);
        const coltype = elements.find(x => x.name == 'columntype');
        if (coltype && coltype.settingValue) {
          const newtype =  Number(coltype.settingValue) as ColumnTypes;
          if (init && this.validationColumnToView.colType != newtype && init)
          {
            this.hint.set('Spaltentyp wurde geändert von ' + ColumnTypes[this.validationColumnToView.colType] + ' zu ' + ColumnTypes[newtype]);
          }
          this.validationColumnToView.colType = newtype;

          this.selectAllAvailableColumns$.pipe(take(1)).subscribe(allcols => {
            this.fndAvailablecol = allcols.find(x => x.dbMapping == e.value.settingValue && x.colType == this.validationColumnToView.colType);
            if (this.validationColumnToView.id == 0 && this.fndAvailablecol && this.validationColumnToView.colType == ColumnTypes.List) {
              this.store.dispatch(new GetStaticListValuesAction({ columnlistid: this.fndAvailablecol.id, listtabletype: ItemValueListTypeTable.AVAILABLECOLUMNS }));
              this.selectStaticUsedlistValues$.subscribe(data => {
                if (data && this.validationColumnToView.id == 0 && data[this.fndAvailablecol.id]) {
                  this.listValue.valuelist = data[this.fndAvailablecol.id].map(x => <any>{ item: x.value });;
                }
              })
            }
          })
        }
        const bub = elements.find(x => x.name == 'bubmapping');
        if (bub && bub.settingValue) {
          if (init && this.validationColumnToView.bubMapping != bub.settingValue) {
            this.hint.set('BubMapping wurde geändert');
          }
          if (this.validationColumnToView.dbMapping == e.value.settingValue) {
            this.validationColumnToView.bubMapping = bub.settingValue;
          }
        }
        const desc = elements.find(x => x.name == 'description');
        if (desc && !init) {
          if (!this.validationColumnToView.colDesc || this.validationColumnToView.colDesc.indexOf(desc.settingValue) == -1) {
            this.validationColumnToView.colDesc = desc?.settingValue;
          }
        }
      }
      this.changeListenTyp({ value: this.validationColumnToView.colType });
    })

  }


  clearValidations() {
    this.validationColumnToView.listOptions = 0;
    this.validationColumnToView.maxLength = 0;
    this.validationColumnToView.isNumberOnly = 0;
    this.validationColumnToView.minLength = 0;
    this.validationColumnToView.validRegEx = undefined;
    this.validationColumnToView.maxDigits = 0;
    this.validationColumnToView.maxDecimals = 0;
    this.validationColumnToView.requiredColumnValue = undefined;
    this.validationColumnToView.notColumnValue = undefined;

  }

  canSave()
  {
    return this.validationColumnToView.colName;
  }

  close() {

    switch (this.validationColumnToView.colType) {

      case (ColumnTypes.EAN):
          this.clearValidations();
        break;
      case (ColumnTypes.Text):
          this.clearValidations();
          this.validationColumnToView.maxLength = this.textValue.maxlength;
          this.validationColumnToView.minLength = this.textValue.minlength;
          this.validationColumnToView.validRegEx = this.textValue.validregex;
          this.validationColumnToView.requiredColumnValue = this.textValue.requiredcolumnvalue;
          this.validationColumnToView.notColumnValue = this.textValue?.notcolumnvalue?.join(";");

        break;
      case (ColumnTypes.DateRange):
        this.clearValidations();
        break;
      case (ColumnTypes.NumberRange):
        this.clearValidations();
        break;
      case (ColumnTypes.List):
        this.clearValidations();

        if (this.validationColumnToView.id > 0) {
          this.store.dispatch(new UpdateStaticListValuesAction({
            columnlistid: this.validationColumnToView.id, items:
              this.listValue.valuelist.map(x => <ItemValueModel>{ label: x.item, value: x.item }), listtabletype: ItemValueListTypeTable.LISTCOLUMNS
          }));
        } else {
          this.validationListColumns$.subscribe(saved => {
            const col = this.validater.getClone(saved).sort((a,b) => b.id-a.id).find(x => x.colName == this.validationColumnToView.colName && x.colType == this.validationColumnToView.colType);
            if (col) {
              this.store.dispatch(new UpdateStaticListValuesAction({
                columnlistid: col.id, items:
                  this.listValue.valuelist.map(x => <ItemValueModel>{ label: x.item, value: x.item }), listtabletype: ItemValueListTypeTable.LISTCOLUMNS
              }));
            }
          }
          )
        }


        break;
      case (ColumnTypes.Number):
        this.clearValidations();
        this.validationColumnToView.isNumberOnly = this.numberValue.isnumberonly ? 1 : 0;
        this.validationColumnToView.maxDigits = this.numberValue.maxdigits;
        this.validationColumnToView.maxDecimals = this.numberValue.maxdecimals;
        this.validationColumnToView.requiredColumnValue = this.numberValue?.requiredcolumnvalue;
        this.validationColumnToView.notColumnValue = this.numberValue?.notcolumnvalue?.join(";");

        this.validationColumnToView.minNumber =  this.numberValue.minNumber;
        this.validationColumnToView.maxNumber =  this.numberValue.maxNumber;

        break;
      case (ColumnTypes.CheckBox):
        this.clearValidations();
        this.validationColumnToView.requiredColumnValue = this.checkBoxValue.requiredcolumnvalue;
        this.validationColumnToView.notColumnValue = this.checkBoxValue?.notcolumnvalue?.join(";");


        break;
      case (ColumnTypes.Date):
        this.clearValidations();
        break;
      case (ColumnTypes.DynamicList):
        this.clearValidations();
        this.validationColumnToView.listOptions = this.dynmlistValue.value;
        this.validationColumnToView.requiredColumnValue = this.referenceColumnValueDynList;
        this.validationColumnToView.notColumnValue = this.referenceNOTColumnValueDynList?.join(";");
        break;

    }
    this.ref.close(this.validationColumnToView);
  }

  cancel() {
    this.ref.close();
  }

  deleteListValue(itemValue: string) {
    const idx = this.listValue.valuelist.findIndex(x => x.item == itemValue);
    this.listValue.valuelist.splice(idx, 1);
  }

  addNewListValue() {
    this.listValue.valuelist.push({ item: "Neuer Eintrag" });
    this.listValue.valuelist = [...this.listValue.valuelist];
  }
}
